import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { CartItemV2 } from '@/types/so';

import ChangeDateBtn from '../ChangeDateBtn';
import styles from './index.module.scss';
import { NewTracking } from '@/constants/track';
import { formatImpression, sendEvent } from '@weee-fe/weee-biz-web';

const Purchased = ({ className }: { className?: string }) => {
  const { t } = useTranslation('common');
  return (
    <button
      className={classNames(
        'enki-body-3xs-strong text-surface-200-fg-default',
        styles.container,
        styles.purchased,
        className
      )}
      data-role="unAvailableButton">
      {t('purchased')}
    </button>
  );
};
const ChangeOtherDay = ({ item, className, data = {} }: { item: CartItemV2; className?: string; data?: any }) => {
  const { t } = useTranslation('common');
  return (
    <div
      data-testid="wid-change-other-day-button"
      onClick={e => {
        e.stopPropagation();
      }}
      data-role="changeOtherDayButton">
      <ChangeDateBtn
        item={item}
        onShow={() => {
          sendEvent({
            type: NewTracking.clickAction,
            params: {
              co: {
                ...(formatImpression.formatProductInfo(data, false) as any),
                target_nm: data.id,
                target_pos: 0,
                target_type: 'product_change_date',
                click_type: 'view'
              }
            }
          });
        }}>
        <button
          data-testid="wid-change-other-day-button-inner"
          className={classNames(styles.container, styles.changeDay, className)}
          data-role="unAvailableButton">
          {item?.buttonText || t('Change_Date')}
        </button>
      </ChangeDateBtn>
    </div>
  );
};

export { Purchased, ChangeOtherDay };
